import i18next from "i18next";
import { lazy } from "react";

import { getHiddenRoute } from "util/react";

import EN from "./i18n/en.json";

i18next.addResourceBundle("en", "ExportPanelArticle", EN);

export const URIS = {
  LIST: "/export-panel-article",
  EDIT: "/export-panel-article/:id",
  NEW: "/export-panel-article/new",
};

export const ExportPanelArticleListRoute = getHiddenRoute(
  "ExportPanelArticle",
  "menu.main",
  URIS.LIST,
  lazy(() => import("./layout/ExportPanelArticleListLayout")),
  null,
  ["admin"],
);
export const ExportPanelArticleCreateRoute = getHiddenRoute(
  "ExportPanelArticle",
  "menu.main",
  URIS.NEW,
  lazy(() => import("./layout/ExportPanelArticleEditLayout")),
  null,
  ["admin"],
);
export const ExportPanelArticleEditRoute = getHiddenRoute(
  "ExportPanelArticle",
  "menu.main",
  URIS.EDIT,
  lazy(() => import("./layout/ExportPanelArticleEditLayout")),
  null,
  ["admin"],
);

const ExportPanelArticleRoute = (
  <>
    {ExportPanelArticleListRoute}
    {ExportPanelArticleCreateRoute}
    {ExportPanelArticleEditRoute}
  </>
);

export default ExportPanelArticleRoute;
